import React from 'react';
import { Clock, AlertTriangle } from 'lucide-react';
import { EstadoRun } from './EstadoRun';
import { ESTADO_RUN, cadaTxt } from './procesosUtils';
import { fmtDuracion, haceCuanto } from '../actividad/actividadUtils';

const tono = (p) => (p.ultima.estado === 'error' ? 'border-rose-300' : p.atrasado ? 'border-amber-300' : 'border-slate-200');

export const ProcesoCard = ({ p, activo, onClick, index }) => (
  <button
    type="button" onClick={onClick} data-testid={`proc-card-${p.proceso}`}
    style={{ animationDelay: `${index * 40}ms` }}
    className={`act-rise text-left rounded-2xl border bg-white p-4 transition-[box-shadow,transform] duration-200 hover:-translate-y-0.5 hover:shadow-md ${tono(p)} ${activo ? 'ring-2 ring-teal-600/50' : ''}`}
  >
    <div className="flex items-start justify-between gap-2">
      <div className="min-w-0">
        <p className="text-[10px] font-semibold uppercase tracking-[0.14em] text-slate-400 truncate">{p.grupo}</p>
        <p className="font-bold text-slate-900 leading-tight truncate" title={p.nombre}>{p.nombre}</p>
      </div>
      {p.atrasado && p.ultima.estado !== 'error'
        ? <span className="inline-flex items-center gap-1 rounded-full border border-amber-200 bg-amber-50 px-2 py-0.5 text-[11px] font-semibold text-amber-800" data-testid={`proc-atrasado-${p.proceso}`}><AlertTriangle size={11} /> Atrasado</span>
        : <EstadoRun estado={p.ultima.estado} testid={`proc-estado-${p.proceso}`} />}
    </div>
    <p className="mt-2 text-xs text-slate-500 flex items-center gap-1.5">
      <Clock size={12} /> {haceCuanto(p.ultima.inicio)}
      {p.ultima.duracion_seg != null && <span>· duró {fmtDuracion(p.ultima.duracion_seg)}</span>}
      {cadaTxt(p.cada_min) && <span className="text-slate-400">· {cadaTxt(p.cada_min)}</span>}
    </p>
    <div className="mt-3 flex items-end gap-[3px] h-5" aria-label="Últimas corridas">
      {p.historial.map((e, i) => (
        <span key={i} title={ESTADO_RUN[e]?.label || e} className={`w-1.5 rounded-sm ${ESTADO_RUN[e]?.dot || 'bg-slate-300'} ${e === 'error' ? 'h-5' : 'h-3'}`} />
      ))}
    </div>
    <p className="mt-2 text-xs text-slate-600 tabular-nums">
      {p.corridas} corrida{p.corridas === 1 ? '' : 's'} en el período
      {p.errores > 0 && <span className="ml-1 font-semibold text-rose-600">· {p.errores} con error</span>}
    </p>
    {p.ultima.estado === 'error' && p.ultima.error && (
      <p className="mt-2 rounded-lg bg-rose-50 px-2 py-1.5 text-[11px] text-rose-700 line-clamp-2" title={p.ultima.error}>{p.ultima.error}</p>
    )}
  </button>
);

export default ProcesoCard;
